



import React, {useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {Minus,Activity ,GripVertical,ChevronLeft,X,Plus ,Phone,Check,Video,MonitorPlay,BookOpenCheck,
  TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Youtube} from 'lucide-react';


  
import "../../CreateCourse/YoutubeVideosAddMore.css";
const AddDemoVideosAddMoreSubCourse=({index ,handleDragStartCard,handleDropCard,handleDragOverCard,
  handleDragEndCard,setHoveredDropZone,
  youtubeLink,youtubeLinkTitle,no,id,totalNumber,status,contentIcon,editable,onRemove,changeItemTitle,changeItemLink})=>{
  const dispatch = useDispatch();  
  const handleMouseEnter = () =>dispatch({
    type: "CURSOR",
    
    payload:true
  });
  const handleMouseLeave = () => dispatch({
    type: "CURSOR",
    
    payload:false
  });
  const [totalNo, setTotalNo] = useState(totalNumber);
    const [areYouSure, setAreYouSure] = useState(false);
    const [isSelected, setIsSelected] = useState(status); 
    const [itemTitle, setItemTitle] = useState(youtubeLinkTitle); 
    const [itemLink, setItemLink] = useState(youtubeLink); 
    const [enableEdit, setEnableEdit] = useState(false); 
  

    const RenderIcon = ({ componentString }) => {
      // Check the componentString to decide which icon to render
      if (componentString === 'BookOpenCheck') {
        return <BookOpenCheck color="#958FDA" size={32} />;
      } if (componentString === 'Video') {
        return <Youtube color="#958FDA" size={32} />;
      }if (componentString === 'MonitorPlay') {
        return <MonitorPlay color="#958FDA" size={32} />;
      }if (componentString === 'NotepadText') {
        return <NotepadText color="#958FDA" size={32} />;
      }if (componentString === 'TabletSmartphone') {
        return <TabletSmartphone color="#958FDA" size={32} />;
      }if (componentString === 'BookDown') {
        return <BookDown color="#958FDA" size={32} />;
      }if (componentString === 'GalleryHorizontal') {
        return <GalleryHorizontal color="#958FDA" size={32} />;
      }if (componentString === 'BookA') {
        return <BookA color="#958FDA" size={32} />;
      }if (componentString === 'BookOpenCheck') {
        return <BookOpenCheck color="#958FDA" size={32} />;
      }if (componentString === 'BadgePlus') {
        return <BadgePlus color="#958FDA" size={32} />;
      }if (componentString === 'GripVertical') {
        return <GripVertical color="#958FDA" size={32} />;
      }


      // Add more cases if needed for other icons
    
      return null;
    };
     useEffect(()=>{
      setIsSelected(status)
     },[])


     function getYouTubeThumbnailCoursePage(input) {
      try {
        // Extract video token
        const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
        let videoId;
    
        if (input.startsWith("<iframe")) {
          const srcMatch = input.match(/src="([^"]+)"/);
          if (!srcMatch) {
            throw new Error("No src attribute found in the iframe tag");
          }
          const srcUrl = srcMatch[1];
          const match = srcUrl.match(regex);
          videoId = match ? match[1] : null;
        } else {
          const match = input.match(regex);
          videoId = match ? match[1] : null;
        }
    
        if (!videoId) {
          throw new Error("No video token found");
        }
    
        // Return thumbnail URLs
        return {
          default: `https://img.youtube.com/vi/${videoId}/default.jpg`,
          highQuality: `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`,
          mediumQuality: `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`,
          standardDefinition: `https://img.youtube.com/vi/${videoId}/sddefault.jpg`,
          maxResolution: `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`,
        };
      } catch (error) {
        console.error("Error extracting thumbnail:", error.message);
        return null;
      }
    }
    
   return(<><div 
    align="left" 
   
   style={{padding:"5px",margin:"5px",borderRadius:"10px",background:"#fff",width:"98%",
   boxShadow: "0 7px 20px 0 rgba(48, 25, 131, 0.053)",border:"1px solid #f1f1f1",minHeight:"210px"}}> 
    
   
<div   style={{}}>
    <div>
    <div className="" >
    
      <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  style={{width:"50px",height:"50px",
      borderRadius:"50%",
        float:"left",alignContent:"center",textAlign:"center",padding:"5px"}}>
          <GripVertical color="#958FDA" size={32} />
          </div> 
          {getYouTubeThumbnailCoursePage(itemLink)?enableEdit? <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} style={{width:"70px",height:"40px",
      borderRadius:"10px",
        float:"right",alignContent:"center",textAlign:"center",padding:"5px",cursor:"pointer",float:"right",
       
        margin:"10px", color:"#fff",fontSize:"18px",fontWeight:"bold",
          background:"#958FDA"}} onClick={()=>{onRemove(id);}}>
       Remove </div>:"":<div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} style={{width:"70px",height:"40px",
      borderRadius:"10px",
        float:"right",alignContent:"center",textAlign:"center",padding:"5px",cursor:"pointer",float:"right",
       
        margin:"10px", color:"#fff",fontSize:"18px",fontWeight:"bold",
          background:"#958FDA"}} onClick={()=>{onRemove(id);}}>
       Remove </div>}
         </div>
         {getYouTubeThumbnailCoursePage(itemLink)?!enableEdit?
         <><h3 style={{padding:"5px",paddingTop:"10px",marginTop:"10px"}}>{itemTitle}</h3>
         {enableEdit? "":<div onMouseEnter={handleMouseEnter}
       onMouseLeave={handleMouseLeave} onClick={()=>setEnableEdit(true)}  style={{width:"70px",height:"40px",
        borderRadius:"10px",
          float:"right",alignContent:"center",textAlign:"center",padding:"5px",cursor:"pointer",float:"right",
         
          margin:"10px", color:"#fff",fontSize:"18px",fontWeight:"bold",
            background:"#958FDA"}}>
            Edit
            </div>}{getYouTubeThumbnailCoursePage(itemLink)?
               <img style={{padding:"5px",borderRadius:"10px",width : "200px"}}
           src={getYouTubeThumbnailCoursePage(itemLink)?.maxResolution} 
       />:<img style={{padding:"5px",borderRadius:"10px",width : "200px"}}
       src="https://via.placeholder.com/120x80?text=Image+Not+Found" 
   />} </>:<><div onMouseEnter={handleMouseEnter}
   onMouseLeave={handleMouseLeave} onClick={()=>setEnableEdit(false)}  style={{width:"30px",height:"40px",
    borderRadius:"10px",
      float:"right",alignContent:"center",textAlign:"center",padding:"5px",cursor:"pointer",float:"right",
     
      margin:"10px", boxShadow:"0 7px 20px 0 rgba(1,1,1,0.051)",cursor:"pointer",fontSize:"18px",fontWeight:"bold",border:"0px dashed #958FDA",
        }}>
        <X color="#958FDA" size={32} />
        </div>
   <input onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} value={itemTitle} type="text"placeholder={"Title For Video "+(index+1)}
        onChange={(e)=>{changeItemTitle(id,e.target.value);setItemTitle(e.target.value);}}
        style={{}}  className="inputDemoVideo"></input>
    
     <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} rows={2} value={itemLink} type="text"placeholder={"Add Youtube Video Link "+(index+1)}
        onChange={(e)=>{changeItemLink(id,e.target.value);setItemLink(e.target.value);}}
        style={{}}  className="inputDemoVideo"></textarea></>:<>
        <input onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave} value={itemTitle} type="text"placeholder={"Title For Video "+(index+1)}
             onChange={(e)=>{changeItemTitle(id,e.target.value);setItemTitle(e.target.value);}}
             style={{}}  className="inputDemoVideo"></input>
         
          <textarea onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave} rows={2} value={itemLink} type="text"placeholder={"Add Youtube Video Link "+(index+1)}
             onChange={(e)=>{changeItemLink(id,e.target.value);setItemLink(e.target.value);}}
             style={{}}  className="inputDemoVideo"></textarea></>}
         
    </div>
    
    </div>
    
    </div></>)
}  

export default AddDemoVideosAddMoreSubCourse;
